import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromConfig from '../../store/config/config.reducer';
import { AppState } from '../../store';
import { environment } from '../../environments/environment';
import { NxViewportService } from '@aposin/ng-aquila/utils';
import { debounceTime, map, startWith } from 'rxjs';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { staticGlobtroterPaths } from './static-globtroter-paths';

export const mobileBreakpoint = 1350;
export const debounceTimeViewportChange = 100;
@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent {
  readonly staticGlobtroterPaths = staticGlobtroterPaths;

  globtroterMenuConfig$ = this.store.select(fromConfig.selectGlobtroterMenuConfig);
  globtroterUserName$ = this.store.select(fromConfig.selectGlobtroterUserName);
  globtroterTheme$ = this.store.select(fromConfig.selectGlobtroterTheme);
  globtroterApp = environment.globtroterApp;
  isMobileView$ = this.viewportService.viewportChange$.pipe(
    startWith(window.innerWidth),
    debounceTime(debounceTimeViewportChange),
    map((width) => width < mobileBreakpoint),
  );

  constructor(
    private store: Store<AppState>,
    private viewportService: NxViewportService,
    private readonly dialogService: NxDialogService,
  ) {}

  openModal() {
    this.dialogService.open(MobileMenuComponent, { showCloseIcon: true, fullscreen: true });
  }
}
